<template>
  <div class="table-wrap">
    <table v-if="executors.length" class="executors-table">
      <colgroup>
        <col class="col-id" />
        <col class="col-company" />
        <col class="col-manager" />
        <col class="col-driver" />
        <col class="col-car" />
        <col class="col-trailer" />
        <col class="col-access" />
      </colgroup>
      <thead>
        <tr>
          <th>ID</th>
          <th>Компания</th>
          <th>Менеджер</th>
          <th>Водитель</th>
          <th>Автомобиль</th>
          <th>Прицеп</th>
          <th>Доступ</th>
        </tr>
      </thead>
      <tbody>
        <tr
          v-for="row in executors"
          :key="row.id"
          class="row-card"
          @click="$router.push(`/executors/${row.id}`)"
        >
          <td>{{ row.id }}</td>
          <td :title="companyTitle(row)">
            <span class="company-line">{{ row.name || '—' }}</span>
            <span v-if="row.inn" class="inn-line">{{ row.inn }}</span>
          </td>
          <td>{{ row.manager_name || '—' }}</td>
          <td>{{ driverName(row) }}</td>
          <td>{{ row.car_number || '—' }}</td>
          <td>{{ row.trailer_number || '—' }}</td>
          <td>
            <span :class="['access-badge', isExecutorAvailable(row) ? 'access-yes' : 'access-no']">
              {{ isExecutorAvailable(row) ? 'Доступен' : 'Недоступен' }}
            </span>
          </td>
        </tr>
      </tbody>
    </table>

    <div v-else class="state-block">
      {{ isSearchActive ? 'Исполнителей по выбранным фильтрам нет.' : 'Список исполнителей пуст.' }}
    </div>

    <my-pagination
      v-if="totalPages > 1 || isSearchActive"
      :currentPage="currentPage"
      :totalPages="totalPages"
      @pageChanged="changePage"
    />
  </div>
</template>

<script>
import { computed } from 'vue';
import { useStore } from 'vuex';
import { isExecutorAvailable } from '@/pages/securityCheck/helpers/executorSearchPayload.mjs';

export default {
  name: 'ExecutorTable',
  props: {
    executors: {
      type: Array,
      default: () => [],
    },
    isSearchActive: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['page-changed'],
  setup(_, { emit }) {
    const store = useStore();

    const changePage = (page) => {
      emit('page-changed', page);
    };

    const driverName = (row) => {
      const parts = [row.first_name, row.last_name, row.surname].filter(Boolean);
      return parts.length ? parts.join(' ') : '—';
    };

    const companyTitle = (row) => {
      if (row.inn && row.name) return `${row.inn} — ${row.name}`;
      return row.name || row.inn || '—';
    };

    return {
      totalPages: computed(() => store.state.executors.executors.items.totalPages),
      currentPage: computed(() => store.state.executors.executors.items.currentPage),
      changePage,
      driverName,
      companyTitle,
      isExecutorAvailable,
    };
  },
};
</script>

<style scoped>
.table-wrap {
  flex: 1;
  overflow: auto;
}

.executors-table {
  width: 100%;
  border-collapse: collapse;
  table-layout: fixed;
  font-size: 13px;
}

.executors-table th,
.executors-table td {
  height: 36px;
  padding: 6px 8px;
  border-bottom: 1px solid #edf0f3;
  text-align: left;
  vertical-align: middle;
  overflow: hidden;
  text-overflow: ellipsis;
}

.executors-table th {
  position: sticky;
  top: 0;
  z-index: 1;
  background: #f7f8fa;
  color: #444;
  font-weight: 700;
  white-space: nowrap;
}

.executors-table tbody tr:hover {
  background: #f3f6fb;
}

.row-card {
  cursor: pointer;
}

.col-id { width: 70px; }
.col-company { width: 240px; }
.col-manager { width: 150px; }
.col-driver { width: 170px; }
.col-car { width: 120px; }
.col-trailer { width: 120px; }
.col-access { width: 120px; }

.company-line {
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.inn-line {
  display: block;
  color: #667085;
  font-size: 12px;
}

.access-badge {
  display: inline-flex;
  align-items: center;
  border-radius: 10px;
  padding: 2px 7px;
  font-size: 12px;
  font-weight: 600;
}

.access-yes {
  background: #e6f4ea;
  color: #1e7e34;
}

.access-no {
  background: #fff4e5;
  color: #b26a00;
}

.state-block {
  padding: 32px;
  color: #667085;
  font-size: 14px;
}
</style>
